export const europeanUnionCountries = [
    'España', 'Austria', 'Bélgica', 'Bulgaria', 'Croacia', 'Chipre', 'República Checa', 
    'Dinamarca', 'Estonia', 'Finlandia', 'Francia', 'Alemania', 'Grecia', 'Hungría', 
    'Irlanda', 'Italia', 'Letonia', 'Lituania', 'Luxemburgo', 'Malta', 
    'Países Bajos', 'Polonia', 'Portugal', 'Rumanía', 'Eslovaquia', 'Eslovenia', 
    'Suecia'
  ];